<div
  class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center"
>
  <i class="bi bi-check-lg text-primary display-4"></i>
  <div class="fw-bold text-primary fs-4">{{ "success" | transloco }}!</div>
  <div class="text-muted fs-5 w-75">
    <p class="my-3">{{ "success_registration_info_1" | transloco }}</p>
    <p class="my-3">{{ "success_registration_info_2" | transloco }}</p>
  </div>
  <div class="d-flex justify-content-center gap-2 fs-4">
    <a
      [routerLink]="['/sign-in']"
      routerLinkActive="router-link-active"
      class="link-primary"
      >{{ "sign_in" | transloco }}</a
    >
  </div>
</div>
